import _assign from "object-assign";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { createAction, createColorPalette, createContainer, createDisabled, createEditable, createElevation, createFocusable, createIconography, createOverlayable, createSelectable, createSize, createStatus, createStatusNext, createTypographyOld, createTypography, lightShadows, darkShadows } from '@jpmuitk/style';
import createTheme from './createTheme';

var _createTheme = createTheme({
  spacing: 16
}),
    createSpacingMixinTouch = _createTheme.spacing;

var _createTheme2 = createTheme({
  spacing: 12
}),
    createSpacingMixinLow = _createTheme2.spacing;

var _createTheme3 = createTheme({
  spacing: 8
}),
    createSpacingMixinMedium = _createTheme3.spacing;

var _createTheme4 = createTheme({
  spacing: 4
}),
    createSpacingMixinHigh = _createTheme4.spacing;

var _createTheme5 = createTheme(),
    zIndex = _createTheme5.zIndex;

var densitySpacing = {
  touch: {
    spacing: createSpacingMixinTouch
  },
  low: {
    spacing: createSpacingMixinLow
  },
  medium: {
    spacing: createSpacingMixinMedium
  },
  high: {
    spacing: createSpacingMixinHigh
  }
};

var createThemeCharacteristics = function createThemeCharacteristics(options) {
  var action = options.action,
      container = options.container,
      disabled = options.disabled,
      editable = options.editable,
      elevation = options.elevation,
      focusable = options.focusable,
      iconography = options.iconography,
      overlayable = options.overlayable,
      palette = options.palette,
      selectable = options.selectable,
      size = options.size,
      _options$spacing = options.spacing,
      spacing = _options$spacing === void 0 ? densitySpacing : _options$spacing,
      status = options.status,
      typographyOld = options.typographyOld,
      typography = options.typography,
      otherOptions = _objectWithoutProperties(options, ["action", "container", "disabled", "editable", "elevation", "focusable", "iconography", "overlayable", "palette", "selectable", "size", "spacing", "status", "typographyOld", "typography"]);

  var colorPalette = createColorPalette(palette);
  var palettes = {
    iconography: createIconography(colorPalette, iconography),
    palette: colorPalette,
    typographyOld: createTypographyOld(colorPalette, typographyOld),
    typography: createTypography(typography)
  };
  var elevationShadows = palette.type === 'dark' ? darkShadows : lightShadows;

  var characteristics = _assign({}, otherOptions, {
    action: createAction(palettes, action),
    container: createContainer(colorPalette, container),
    disabled: createDisabled(colorPalette, disabled),
    editable: createEditable(colorPalette, editable),
    elevation: createElevation(elevationShadows, elevation),
    focusable: createFocusable(colorPalette, focusable),
    overlayable: createOverlayable(zIndex, overlayable),
    size: createSize(size),
    selectable: createSelectable(colorPalette, selectable),
    spacing: spacing,
    status: createStatus(colorPalette, status),
    statusNext: createStatusNext(colorPalette, status)
  }, palettes);

  return characteristics;
};

export default createThemeCharacteristics;